'use client';
import * as Icon from '@/ui/Icon';
import * as Styled from './styled';
import { Simple as Tooltip } from '@/ui/Tooltip';
import JsonView from '@/components/JsonView';

import { RenderHeaderCellProps } from 'react-data-grid';
import { ColumnWithDType } from '../../types';
import { TRenderAsEnum } from '../../DataGrid/lib';

const DEFAULT_COLLAPSE_DEPTH = 1;

import { Row } from '@/ui/primatives';
import MaybeEvalStatus from '../MaybeEvalStatus';

export const Details: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    field: ColumnWithDType;
    value: string;
    rootPath?: string;
    collapseDepth?: number;
  }
> = ({ field, value, rootPath, collapseDepth = DEFAULT_COLLAPSE_DEPTH, ...rest }) => {
  const listItems = value; //?.toString().trim().split(',');
  return (
    <Styled.ListDetails {...rest}>
      <MaybeEvalStatus value={value}>
        <JsonView json={listItems} collapseDepth={collapseDepth} />
      </MaybeEvalStatus>
      {/* <Row alignItems="center" gap={20}>
        <span>{value}</span>
      </Row> */}
    </Styled.ListDetails>
  );
};

const SampleCellContents: React.FC<{ value: any }> = ({ value }) => {
  const listCount = value?.length;
  const sampleItems = value?.slice(0, 3);

  if (!sampleItems) {
    return null;
  }

  const sampleString = JSON.stringify(sampleItems)?.substring(0, 60) || '???';
  return (
    <>
      {sampleString}, ... <span className="count">{listCount} items</span>
    </>
  );
};

export const Cell: React.FC<
  React.HTMLAttributes<HTMLDivElement> & { field: ColumnWithDType; value: any; renderAs: TRenderAsEnum }
> = ({ field, value, renderAs, ...rest }) => {
  return (
    <Styled.ListCell {...rest}>
      <MaybeEvalStatus value={value}>
        <SampleCellContents value={value} />
      </MaybeEvalStatus>
    </Styled.ListCell>
  );
};

export const Header: React.FC<{ children: React.ReactNode } & RenderHeaderCellProps<any>> = (props) => {
  // const field = props.column as ColumnWithDType;
  // const renderFunction = field?.metadata?._oxen?.render;
  return (
    <Row alignItems="center" justifyContent="space-between" gap={10}>
      <span>{props.column.name}</span>
      <Row alignItems="center" gap={10}>
        <Tooltip content={`The content in the cell is derived from the custom list renderer`}>
          <Icon.QuestionCircle />
        </Tooltip>
        {props.children}
      </Row>
    </Row>
  );
};
